(function(){if(window.innerWidth>749||!document.querySelector('.buy-buttons-block, [class*="buy-buttons"]'))return;const originalForm=document.querySelector('form[action*="/cart/add"]'),originalBtn=document.querySelector('button[name="checkout"], .cart__checkout-button, [class*="add-to-cart"] button, button[type="submit"][name="add"]');if(!originalForm)return;const sticky=document.createElement("div");sticky.className="knagen-sticky-atc",sticky.innerHTML='<button class="knagen-sticky-atc__btn" type="button">Legg i handlekurv</button>',document.body.appendChild(sticky),sticky.querySelector(".knagen-sticky-atc__btn").addEventListener("click",function(){const addBtn=document.querySelector('button[name="add"], [class*="add-to-cart"]');addBtn&&addBtn.click()});function checkVisibility(){const rect=originalForm.getBoundingClientRect();rect.top>=0&&rect.bottom<=window.innerHeight?sticky.classList.remove("visible"):(rect.top<0||rect.bottom>window.innerHeight+100)&&sticky.classList.add("visible")}window.addEventListener("scroll",checkVisibility,{passive:!0}),checkVisibility()})(),(function(){"use strict";function initSwipe(){document.querySelectorAll(".card-gallery:not([data-swipe-init])").forEach(function(gallery){var slideshow=gallery.querySelector("slideshow-component");if(!slideshow)return;var slides=slideshow.querySelectorAll("slideshow-slide");if(slides.length<2)return;gallery.setAttribute("data-swipe-init","1");var indicators=document.createElement("div");indicators.className="knagen-indicators";for(var i=0;i<slides.length;i++){var dash=document.createElement("span");dash.className="knagen-dash"+(i===0?" is-active":""),indicators.appendChild(dash)}slideshow.appendChild(indicators);var currentIdx=0,dashes=indicators.querySelectorAll(".knagen-dash"),prevBtn=gallery.querySelector(".slideshow-control--previous"),nextBtn=gallery.querySelector(".slideshow-control--next");function goTo(idx){currentIdx=Math.max(0,Math.min(idx,slides.length-1)),dashes.forEach(function(d,i2){d.classList.toggle("is-active",i2===currentIdx)})}prevBtn&&prevBtn.addEventListener("click",function(){goTo(currentIdx-1)}),nextBtn&&nextBtn.addEventListener("click",function(){goTo(currentIdx+1)});var tx=0,ty=0;slideshow.addEventListener("touchstart",function(e){tx=e.touches[0].clientX,ty=e.touches[0].clientY},{passive:!0}),slideshow.addEventListener("touchend",function(e){var dx=e.changedTouches[0].clientX-tx,dy=e.changedTouches[0].clientY-ty;Math.abs(dx)<30||Math.abs(dy)>Math.abs(dx)*.8||(dx<0&&nextBtn?nextBtn.click():dx>0&&prevBtn&&prevBtn.click())},{passive:!0})})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",initSwipe):initSwipe();var t;new MutationObserver(function(){clearTimeout(t),t=setTimeout(initSwipe,150)}).observe(document.documentElement,{childList:!0,subtree:!0})})();
(function(){
  function fix(){
    var s=document.querySelector('[id$="__product_list_fa6P9H"]');
    if(!s)return;
    var header=s.querySelector('.section-resource-list__header');
    var title=s.querySelector('.group-block');
    var prev=s.querySelector('.kn-arrow--prev');
    var next=s.querySelector('.kn-arrow--next');
    var inner=s.querySelector('.section');
    var seeAll=s.querySelector('.kn-seealle-wrap');
    var content=s.querySelector('.section-resource-list__content');
    var resList=s.querySelector('.resource-list');
    if(!header||!title||!prev||!next)return;
    // Flex row: [< arrow] [title] [> arrow] — always same line
    header.style.setProperty('display','flex','important');
    header.style.setProperty('flex-direction','row','important');
    header.style.setProperty('align-items','center','important');
    header.style.setProperty('justify-content','space-between','important');
    header.style.setProperty('padding','0 8px','important');
    header.style.setProperty('position','static','important');
    // Title fills center
    title.style.setProperty('flex','1','important');
    title.style.setProperty('text-align','center','important');
    title.style.setProperty('padding','0','important');
    title.style.setProperty('margin','0','important');
    title.style.setProperty('order','0','important');
    // Arrows as normal flex children
    prev.style.setProperty('position','static','important');
    prev.style.setProperty('top','auto','important');
    prev.style.setProperty('transform','none','important');
    prev.style.setProperty('order','-1','important');
    prev.style.setProperty('flex','none','important');
    next.style.setProperty('position','static','important');
    next.style.setProperty('top','auto','important');
    next.style.setProperty('transform','none','important');
    next.style.setProperty('order','1','important');
    next.style.setProperty('flex','none','important');
    // Compact spacing on mobile
    if(window.innerWidth<=989){
      if(inner){
        inner.style.setProperty('row-gap','16px','important');
        inner.style.setProperty('padding-top','16px','important');
        inner.style.setProperty('padding-bottom','20px','important');
      }
      if(seeAll){
        seeAll.style.setProperty('padding-top','0','important');
        seeAll.style.setProperty('padding-bottom','0','important');
        seeAll.style.setProperty('margin','0','important');
      }
      if(content){content.style.setProperty('padding-top','0','important');content.style.setProperty('margin-top','0','important');}
      if(resList){resList.style.setProperty('padding-top','0','important');resList.style.setProperty('margin-top','0','important');}
    }
  }
  function run(){fix();setTimeout(fix,300);setTimeout(fix,800);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
  window.addEventListener('resize',fix);
})();

/* KN produktgalleri v1 - ingen wrap-around: stopper paa foerste og siste bilde */
(function(){
  if (window.__knNoLoop) return;
  window.__knNoLoop = true;
  function strip(){
    var l = document.querySelectorAll('media-gallery slideshow-component[infinite]');
    for (var i = 0; i < l.length; i++) l[i].removeAttribute('infinite');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', strip); else strip();
  try {
    new MutationObserver(strip).observe(document.documentElement, {
      childList:true, subtree:true, attributes:true, attributeFilter:['infinite']
    });
  } catch(e){}
})();


/* KN sticky kjop-knapp v1 - videresender den store mobilknappen til produktskjemaet */
(function(){
  if (window.__knStickyFix) return; window.__knStickyFix = true;
  function realBtn(){
    var f = document.querySelector('product-form-component form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!f) return null;
    return f.querySelector('button[type="submit"]') || f.querySelector('.add-to-cart-button');
  }
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.knagen-sticky-atc__btn')) return;
    var r = realBtn();
    if (!r) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (r.disabled) return;
    r.click();
  }, true);
})();
